export default __webpack_public_path__ + "static/media/kawaguchiko_lake_japan.9bd06210.webp";